export const PDF_TAB_CONTENT_PROPS = { "data-pdf-content": "true" }
export const PDF_HIDE_WHEN_EMPTY_TAB_PROPS = { "data-pdf-hide-when-empty": "true" }

export const EMPTY_PDF_TAB_SELECTOR =
    "[data-pdf-hide-when-empty='true']:not(:has([data-pdf-content='true'], [data-pdf-loading='true']))"

export const PDF_TAB_SECTION_SX = {
    [`&${EMPTY_PDF_TAB_SELECTOR}`]: { display: "none" },
}
